export enum DocumentViewerMutationTypes {
  SET_REDACT_DOCUMENT_DIALOG = 'SET_REDACT_DOCUMENT_DIALOG',
  SET_REDACT_DOCUMENT_ERROR = 'SET_REDACT_DOCUMENT_ERROR'
}
